import React, {useEffect, useState} from 'react';
import { Container, Image, Row } from 'react-bootstrap';



// // style={{width:"100%" ,height:"100%"}}

function Bannerdisplay() {

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
    
      useEffect(() => {
        const handleResize = () => {
          setIsSmallScreen(window.innerWidth <= 768);
        };
    
        window.addEventListener('resize', handleResize);
    
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);

 


  return (
    <Container 
    fluid 
   className="container-section"
   
    style={{backgroundColor:"#212020",
      display: "flex",
      alignItems: "center", 
      justifyContent: "center", 
      height: isSmallScreen ? "auto" : "100vh",
      paddingTop: isSmallScreen ? "2rem" : "4rem",
      paddingBottom: isSmallScreen ? "2rem" : "4rem",}}><br/>
      <Row>
      <Image 
           src='/assets/olaolabanner.png' 
           alt='banner-image'  
          
           style={{
            Width: "100%",
            
          }}
          />

      </Row>
       
       
  </Container>
  )
}

export default Bannerdisplay;
